<template>
<el-row class="container">
    <el-col :span="24" class="header" style="background: #0099cb">
        <el-col :span="4" class="logo" :class="collapsed?'logo-collapse-width':'logo-width'" @click.native="showMain">
            <template v-if="collapsed">
                卡
            </template>
            <template v-else>
                <label style="font-size:17px">{{sysName}}</label>
            </template>
        </el-col>
        <el-col :span="2">
            <div class="tools" @click.prevent="collapse">
                <i class="fa fa-align-justify"></i>
            </div>
        </el-col>
        <el-col :span="12" class="noticebar">
            <template v-if="noticebar">
                <marquee onmouseover="this.stop()" onmouseout="this.start()"><span class="iconfont icon-notice3" style="font-size:20px;vertical-align:middle;"></span> 公告：系统将于2020-06-01正式上线，有问题可联系13803831229。华为畅享9新品即将上市，活动期间0元预约可参与抽奖，赢HUAWEI WATCH等好礼，更多产品信息请持续关注！</marquee>
            </template>
        </el-col>
        <el-col :span="4" class="userinfo">
            <el-dropdown trigger="hover">
                <span class="el-dropdown-link userinfo-inner"><img :src="this.sysUserAvatar" /> {{sysUserName}}</span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="showUserInfo">个人资料</el-dropdown-item>
                    <el-dropdown-item @click.native="showEditPwd">修改密码</el-dropdown-item>
                    <el-dropdown-item divided @click.native="logout">退出登录</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </el-col>
    </el-col>
    <el-col :span="24" class="main">

        <!--导航菜单-->
        <el-menu default-active="1-4-1" class="el-menu-vertical-demo" :collapse="collapsed" @select="handleSelect" unique-opened background-color="#324757" text-color="#bfd0d9" active-text-color="#0099cb">
            <template v-for="(item,index) in $router.options.routes">	
                <template v-if="!item.hidden">
                    <template v-for="rolepath in rolepaths">
                        <template v-if="!rolepath.hidden">
                            <template v-if="item.name!=null && rolepath.title!= null && item.name==rolepath.title">
                                <template v-if="rolepath.roleChildPaths != null && rolepath.roleChildPaths.length>0">
                                    <el-submenu :index="index+''" v-bind:key="item.name">
                                        <template slot="title"><i :class="item.iconCls" style="color:#bfd0d9;"></i><span slot="title">{{item.name}}</span></template>
                                        <template v-for="child in item.children">
                                            <template v-if="!child.hidden">
                                                <template v-for="childPath in rolepath.roleChildPaths">
                                                    <template v-if="!childPath.hidden">
                                                        <template v-if="child.path!=null && childPath.path!= null && child.path==childPath.path">
                                                            <el-menu-item :index="childPath.path" v-bind:key="childPath.title">{{childPath.title}}</el-menu-item>
                                                        </template>
                                                    </template>
                                                </template>
                                            </template>
                                        </template>
                                    </el-submenu>
                                </template>
                                <template v-else>
                                    <el-menu-item @click="toUrl(rolepath.path)"><i :class="item.iconCls" style="color:#bfd0d9;"></i><span style="color:#bfd0d9;">{{rolepath.title}}</span></el-menu-item>
                                </template>
                            </template>
                        </template>
                    </template>
                </template>
            </template>
        </el-menu>

        <section class="content-container">
            <div class="grid-content bg-purple-light">
                <el-col :span="24" class="breadcrumb-container">
                    <strong class="title">{{$route.name}}</strong>
                    <el-breadcrumb separator="/" class="breadcrumb-inner">
                        <el-breadcrumb-item v-for="item in $route.matched" v-bind:key="item.path">
                            {{ item.name }}
                        </el-breadcrumb-item>
                    </el-breadcrumb>
                </el-col>
                <el-col :span="24" class="content-wrapper">
                    <transition name="fade" mode="out-in">
                        <router-view></router-view>
                    </transition>
                </el-col>
            </div>

            <el-dialog title="修改密码" :visible.sync="editUserPwdFormVisible" :close-on-click-modal="false">
                <el-form ref="editUserPwdForm" :model="editUserPwdForm" :rules="editUserPwdFormRules" label-width="100px">
                    <el-form-item label="账号：">
                        <el-input v-model="editUserPwdForm.username" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item label="手机：">
                        <el-input v-model="editUserPwdForm.contactMobile" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item label="原密码：" prop="sourcePwd">
                        <el-input v-model="editUserPwdForm.sourcePwd" type="password"></el-input>
                    </el-form-item>
                    <el-form-item label="新密码：" prop="newPwd">
                        <el-input v-model="editUserPwdForm.newPwd" type="password"></el-input>
                    </el-form-item>
                    <el-form-item label="确认密码：" prop="okPwd">
                        <el-input v-model="editUserPwdForm.okPwd" type="password"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click.native="editUserPwdFormVisible = false">取消</el-button>
                    <el-button type="primary" @click.native="editUserPwdSubmit" :loading="editLoading">确定</el-button>
                </div>
            </el-dialog>

            <el-dialog title="个人资料" :visible.sync="userInfoFormVisible" :close-on-click-modal="false">
                <el-row>
                    <el-col :span="4" style="padding-top:30px;padding-left:20px;">
                        <img :src="this.sysUserAvatar" />
                    </el-col>
                    <el-col :span="20">
                        <el-form ref="userInfoForm" label-position="left" :model="userInfoForm" label-width="100px" style="margin:20px;width:60%;min-width:600px;">
                            <el-form-item label="姓名：">
                                {{userInfoForm.contactMan}}
                            </el-form-item>
                            <el-form-item label="手机：">
                                <div v-show="!isEditMobile">{{userInfoForm.contactMobile}} <a @click="showEditMobile" style="color:#0099cb;cursor:pointer;">修改</a></div>
                                <div v-show="isEditMobile">
                                    <el-col :span="6">
                                        <el-input v-model="userInfoForm.contactMobile" size="small"></el-input>
                                    </el-col>
                                    <el-col :span="5">
                                        <el-button type="primary" size="small" @click="handleEditMobile">确定</el-button>
                                    </el-col>
                                    <el-col :span="13"></el-col>
                                </div>
                            </el-form-item>
                            <el-form-item label="级别：">
                                {{sysUserName}}
                            </el-form-item>
                            <el-form-item label="上级服务商：">
                                {{userInfoForm.f_contactMan}} {{userInfoForm.f_contactMobile}}
                            </el-form-item>
                            <el-form-item label="平台账号：">
                                {{userInfoForm.username}}
                            </el-form-item>
                            <el-form-item label="注册时间：">
                                {{userInfoForm.regTime}}
                            </el-form-item>
                        </el-form>
                    </el-col>
                </el-row>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click.native="userInfoFormVisible = false">确定</el-button>
                </div>
            </el-dialog>

        </section>
    </el-col>
</el-row>
</template>

<script>
import {
    requestLogout,
    getUserInfo,
    editUserPwd,
    editUserMobile,
    getPath
} from '../api/api';

export default {
    data() {

        //自定义二次密码校验器
        var validPwdSame = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'));
            } else if (value !== this.editUserPwdForm.newPwd) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };

        return {
            sysName: '移动物联卡综合管理系统',
            noticebar: false,
            collapsed: false,
            rolepaths:[],
			userid:'',
            sysUserName: '',
            userlevel: -1,
            sysUserAvatar: '',
            editLoading: false,
            editUserPwdForm: {
                username: '',
                contactMobile: '',
                sourcePwd: '',
                newPwd: '',
                okPwd: ''
            },
            editUserPwdFormRules: {
                sourcePwd: [{
                    required: true,
                    message: '请输入旧密码',
                    trigger: 'blur'
                }],
                newPwd: [{
                    required: true,
                    min: 6,
                    message: '请输入新密码(至少6个字符)',
                    trigger: 'blur'
                }],
                okPwd: [{
                    validator: validPwdSame,
                    trigger: 'blur'
                }]
            },
            editUserPwdFormVisible: false,
            userInfoForm: {
                username: '',
                userlevel: '',
                contactMan: '',
                contactMobile: '',
                regTime: '',
                f_contactMan: '',
                f_contactMobile: ''
            },
            userInfoFormVisible: false,
            isEditMobile: false

        }
    },
    methods: {
		toUrl: function (url) {
			window.open(url);
		},
        showMain() {
            var _this = this;
            _this.$router.push('/main');
        },
        showEditPwd: function () {
            getUserInfo().then(res => {
                this.editUserPwdForm = res.data;
                this.editUserPwdFormVisible = true;
            });
        },
        showUserInfo: function () {
            getUserInfo().then(res => {
                this.userInfoForm = res.data;
                this.userInfoFormVisible = true;
            });
        },
        showEditMobile: function () {
            this.isEditMobile = true;
        },
        handleEditMobile: function () {

            //校验手机号的格式
            let mobile = this.userInfoForm.contactMobile;
            var reg = /^1[0-9]{10}$/;
            if (!reg.test(mobile)) {
                this.$message({
                    message: '请输入正确的手机号码',
                    type: 'error'
                });
            } else {
                //提交到服务器
                var params = {
                    mobile: mobile
                };
                editUserMobile(params).then(res => {
                    this.editLoading = false;
                    let {
                        msg,
                        code
                    } = res;
                    if (code !== 0) {
                        this.$message({
                            message: msg,
                            type: 'error'
                        });
                    } else {
                        this.$message({
                            message: '修改成功',
                            type: 'success'
                        });
                        this.isEditMobile = false;
                    }
                }).catch(() => {
                    this.$message({
                        message: '系统繁忙,请稍候',
                        type: 'error'
                    });
                });

            }

        },
        editUserPwdSubmit() {
            this.$refs.editUserPwdForm.validate((valid) => {
                if (valid) {
                    this.editLoading = true;
                    var editPwdParams = {
                        oldpwd: this.editUserPwdForm.sourcePwd,
                        newpwd: this.editUserPwdForm.newPwd
                    };
                    editUserPwd(editPwdParams).then(res => {
                        this.editLoading = false;
                        let {
                            msg,
                            code
                        } = res;
                        if (code !== 0) {
                            this.$message({
                                message: msg,
                                type: 'error'
                            });
                        } else {
                            this.$message({
                                message: '修改成功',
                                type: 'success'
                            });
                            this.$refs['editUserPwdForm'].resetFields();
                            this.editUserPwdFormVisible = false;
                        }
                    }).catch(() => {
                        console.log('异常!');
                    });

                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        onSubmit() {
            console.log('submit!');
        },
        handleopen() {
            //console.log('handleopen');
        },
        handleclose() {
            //console.log('handleclose');
        },
        handleSelect: function (key, keyPath) {
            console.log( key);
            this.$router.push({
                path: key
            });
        },
        //退出登录
        logout: function () {
            var _this = this;
            this.$confirm('确认退出吗?', '提示', {
                //type: 'warning'
            }).then(() => {
                sessionStorage.removeItem('user');
                requestLogout().then(res => {
                    _this.$router.push('/login');
                });
            }).catch(() => {

            });

        },
        //折叠导航栏
        collapse: function () {
            this.collapsed = !this.collapsed;
        },
        showMenu(i, status) {
            this.$refs.menuCollapsed.getElementsByClassName('submenu-hook-' + i)[0].style.display = status ? 'block' : 'none';
        },
        getPath(){
            var params = { userid: this.userid };
            getPath(params).then((res) => {
                let {msg,code} = res;
                if (code !== 0) {
                    alert('获取权限失败！');
                } else {
                    let data = res.data;
                    if(data != null && data.length>0){
                        this.rolepaths = data;
                    }else{
                        alert('请核实账号是否拥有权限！');
                    }
                }
                
            });
        },
    },
    mounted() {
        var user = sessionStorage.getItem('user');
        if (user) {
            user = JSON.parse(user);
            this.userlevel = user.userlevel;
            this.userid = user.userid;
			this.getPath();
            if (user.userlevel == 0) {
                this.sysUserName = '管理员';
            } else if (user.userlevel == 1) {
                this.sysUserName = '一级服务商';
            } else if (user.userlevel == 2) {
                this.sysUserName = '二级服务商';
            }
            this.sysUserAvatar = 'img/v' + user.userlevel + ".png";
        }
    }
}
</script>

<style lang="scss" scoped>
@import '~scss_vars';

.container {
    position: absolute;
    top: 0px;
    bottom: 0px;
    width: 100%;

    .header {
        height: 60px;
        line-height: 60px;
        background: $color-primary;
        color: #fff;

        .userinfo {
            text-align: right;
            padding-right: 35px;
            float: right;

            .userinfo-inner {
                cursor: pointer;
                color: #fff;

                img {
                    width: 40px;
                    height: 40px;
                    border-radius: 20px;
                    margin: 10px 0px 10px 10px;
                    float: right;
                }
            }
        }

        .logo {
            //width:230px;
            height: 60px;
            font-size: 22px;
            padding-left: 20px;
            padding-right: 20px;
            border-color: rgba(238, 241, 146, 0.3);
            border-right-width: 1px;
            border-right-style: solid;

            img {
                width: 40px;
                float: left;
                margin: 10px 10px 10px 18px;
            }

            .txt {
                color: #fff;
            }
        }

        .logo-width {
            width: 200px;
        }

        .logo-collapse-width {
            width: 65px
        }

        .tools {
            padding: 0px 23px;
            width: 14px;
            height: 60px;
            line-height: 60px;
            cursor: pointer;
        }

        .noticebar {
            text-align:right;
            color:#FFFFFF;
            cursor: default;
        }

    }

    .el-menu-vertical-demo:not(.el-menu--collapse) {
        width: 200px;
        min-height: 400px;
        overflow-y:scroll;
        overflow-x:hidden;
    }

    /*定义滚动条的高宽*/
    .el-menu-vertical-demo::-webkit-scrollbar {
        width: 0px;
        height: 1px;
    }
    /*显示滚动条上方的渐增按钮*/
    .el-menu-vertical-demo::-webkit-scrollbar-button:start:decrement,
    /*显示滚动条上方的渐减按钮*/
    .el-menu-vertical-demo::-webkit-scrollbar-button:end:increment {
        display: block;
    }
    /*隐藏滚动条上方的渐增按钮*/
    .el-menu-vertical-demo::-webkit-scrollbar-button:vertical:start:increment,
    .el-menu-vertical-demo::-webkit-scrollbar-button:vertical:end:decrement {
        display: none;
    }
    /* 定义滚动条渐增按扭的样式 */
    .el-menu-vertical-demo::-webkit-scrollbar-button:end:increment {
        background-color: #f1f1f1;
    }
    /* 定义滚动条渐减按扭的样式 */
    .el-menu-vertical-demo::-webkit-scrollbar-button:start:decrement {
        background-color: #f1f1f1;
    }
    /* 垂直滚动条的滑动块 */
    .el-menu-vertical-demo::-webkit-scrollbar-thumb:vertical {
        height: 56px;
        background-color: #c1c1c1;
    }
    /* 垂直滚动条的第三层轨道的上段 */
    .el-menu-vertical-demo::-webkit-scrollbar-track-piece:vertical:start {
        background-color: #f1f1f1;
    }
    /* 垂直滚动条的第三层轨道的下段 */
    .el-menu-vertical-demo::-webkit-scrollbar-track-piece:vertical:end {
        background-color: #f1f1f1;
    }

    .main {
        display: flex;
        // background: #324057;
        position: absolute;
        top: 60px;
        bottom: 0px;
        overflow: hidden;

        .content-container {
            // background: #f1f2f7;
            flex: 1;
            // position: absolute;
            // right: 0px;
            // top: 0px;
            // bottom: 0px;
            // left: 230px;
            overflow-y: scroll;
            padding: 20px;

            .breadcrumb-container {

                //margin-bottom: 15px;
                .title {
                    width: 200px;
                    float: left;
                    color: #475669;
                }

                .breadcrumb-inner {
                    float: right;
                }
            }

            .content-wrapper {
                background-color: #fff;
                box-sizing: border-box;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// Home.vue?26554171